import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import UIButton from 'UIComponents/button/UIButton';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner'; // @ts-expect-error Untyped import

import ContentControlWrapper from '../../../components/ContentControlWrapper'; // @ts-expect-error Untyped import

import ContentViewport from '../../../components/ContentViewport';
const BASE_CLASS_NAME = 'exam-loading-screen';

const ExamLoadingScreen = () => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx(ContentViewport, {
    paddingClassName: `${BASE_CLASS_NAME}__content`,
    children: /*#__PURE__*/_jsx(UILoadingSpinner, {
      grow: true,
      minHeight: 200
    })
  }), /*#__PURE__*/_jsx(ContentControlWrapper, {
    className: `${BASE_CLASS_NAME}__content-control`,
    children: /*#__PURE__*/_jsx(UIButton, {
      disabled: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.exams.examQuestion.nextButton"
      })
    })
  })]
});

export default ExamLoadingScreen;